module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_Elec_002.fad6c894.png";